// extracted by mini-css-extract-plugin
export var cardTitle = "_i4-1";
export var commentBubble = "_i4-e";
export var commentForm = "_i4-a";
export var commentInput = "_i4-b";
export var commentLabel = "_i4-d";
export var commentPrompt = "_i4-9";
export var csatCard = "_i4-0";
export var feedbackSection = "_i4-7";
export var starDisabled = "_i4-6";
export var starEmpty = "_i4-5";
export var starFilled = "_i4-4";
export var starWrapper = "_i4-3";
export var starsContainer = "_i4-2";
export var submittedComment = "_i4-c";
export var thankYouText = "_i4-8";